import CommandTypes from '../../../Canvas/commands/types';
import add from './add';

const regularPolygonCommands = {
    [CommandTypes.CREATE_SHAPES]: add
};

export default regularPolygonCommands;
